import { Injectable, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { AppPopContentComponent } from './app-pop-content.component';

interface confirmData {
  title?: string;
  message?: string;
}

@Injectable()
export class AppPopContentService implements OnInit {
  constructor(private dialog: MatDialog) {}
  ngOnInit() {}
  public close() {}
  public confirm(data: confirmData = {}): Observable<boolean> {
    data.title = data.title || 'Pop Content';
    data.message = data.message || 'Content';
    let dialogRef: MatDialogRef<AppPopContentComponent>;
    dialogRef = this.dialog.open(AppPopContentComponent, {
      data: { title: data.title, message: data.message },
    });
    return dialogRef.afterClosed();
  }
}
